import React, { useState } from 'react';
import styles from './NotificationSettings.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import P from 'components/P';
import Dummy from 'components/Dummy';

const NotificationSettings = () => {
    const [marketingPush, setMarketingPush] = useState(true);
    const [orderPush, setOrderPush] = useState(true);

    return (
        <div className={styles.container}>
            <Dummy height={"56px"} />
            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <P size={16} weight={600}>푸시 알림</P>
                    <P size={14} color="#666">앱 푸시 알림 수신 설정을 관리합니다.</P>
                </div>

                <div className={styles.settingItem}>
                    <div className={styles.settingInfo}>
                        <P size={15} weight={500}>마케팅 알림</P>
                        <P size={13} color="#999">이벤트 및 혜택 알림을 받습니다.</P>
                    </div>
                    <button 
                        className={`${styles.toggleButton} ${marketingPush ? styles.active : ''}`}
                        onClick={() => setMarketingPush(!marketingPush)}
                    >
                        <div className={styles.toggleCircle} />
                    </button>
                </div>

                <div className={styles.settingItem}>
                    <div className={styles.settingInfo}>
                        <P size={15} weight={500}>주문 알림</P>
                        <P size={13} color="#999">주문 상태 변경 알림을 받습니다.</P>
                    </div>
                    <button 
                        className={`${styles.toggleButton} ${orderPush ? styles.active : ''}`}
                        onClick={() => setOrderPush(!orderPush)}
                    >
                        <div className={styles.toggleCircle} />
                    </button>
                </div>
            </div>

            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <P size={16} weight={600}>알림 수신 내역</P>
                    <P size={14} color="#666">최근 받은 알림을 확인합니다.</P>
                </div>

                <div className={styles.notificationList}>
                    <P>알림 내역이 없습니다.</P>
                    {/* <div className={styles.notificationItem}>
                        <div className={styles.notificationIcon}>
                            <FontAwesomeIcon icon={fas.faBell} />
                        </div>
                        <div className={styles.notificationContent}>
                            <P size={14} weight={500}>신규 이벤트 안내</P>
                            <P size={13} color="#666">새로운 이벤트가 등록되었습니다.</P>
                            <P size={12} color="#999">2024.01.15 14:30</P>
                        </div>
                    </div>

                    <div className={styles.notificationItem}>
                        <div className={styles.notificationIcon}>
                            <FontAwesomeIcon icon={fas.faShoppingBag} />
                        </div>
                        <div className={styles.notificationContent}>
                            <P size={14} weight={500}>주문 완료</P>
                            <P size={13} color="#666">주문이 성공적으로 완료되었습니다.</P>
                            <P size={12} color="#999">2024.01.14 11:20</P>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default NotificationSettings; 